import { FullScreenCalloutAccessModeVariants } from './_props'

export const fullScreenCalloutAccessModeVariants: FullScreenCalloutAccessModeVariants = {
    conforme: {
        title: 'Information importante',
        text: 'Conformément à la PGSSI-S et pour la sécurité des données de santé de vos patients, votre identifiant RPPS de professionnel de santé est obligatoire pour pouvoir utiliser TokTokDoc. Merci de mettre à jour vos informations.',
    },
    flexible: {
        title: 'Identifiant RPPS manquant',
        text: 'Pour garantir la sécurité des données de vos patients, votre identifiant RPPS sera bientôt obligatoire sur TokTokDoc. Merci de mettre à jour les informations de votre compte.',
        buttonName: 'Renseigner mon RPPS',
    },
    psad: {
        title: 'Identifiant RPPS manquant',
        text: 'Veuillez renseigner votre identifiant RPPS dans les informations de votre compte.',
        buttonName: 'Renseigner mon RPPS',
    },
}
